import { useEffect, useState } from "react";
import QRCode from "qrcode";

type Props = {
  data: string;
  width?: number;
  height?: number;
  kiosk?: boolean;
};

const QrCode = ({ data, width, height, kiosk }: Props) => {
  const [qrCode, setQrCode] = useState<string>("");

  useEffect(() => {
    generateQRCode();
  }, [data]);

  const generateQRCode = async () => {
    await QRCode.toDataURL(data, {
      width: 300
    })
      .then((url) => {
        setQrCode(url);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const containerClassName = kiosk ? "" : "photo-booth__qr-code";

  return (
    <div className={containerClassName}>
      <img src={qrCode} alt={data} width={width} height={height} />
    </div>
  );
};

export default QrCode;
